import { render, staticRenderFns } from "./CustomLinkEdit.vue?vue&type=template&id=3368c3f8&scoped=true"
import script from "./CustomLinkEdit.vue?vue&type=script&lang=js"
export * from "./CustomLinkEdit.vue?vue&type=script&lang=js"
import style0 from "./CustomLinkEdit.vue?vue&type=style&index=0&id=3368c3f8&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3368c3f8",
  null
  
)

export default component.exports